import { FunctionComponent, ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Link from '@atlaskit/link';
import { Flex, Text, xcss } from '@atlaskit/primitives';

const messages = defineMessages({
  adminCalloutText: {
    id: 'appUpdates.rolloutScheduleCallout.text',
    defaultMessage:
      'For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.',
    description:
      'Callout encouraging org admins to visit Atlassian Administration for org-specific rollout schedules. The text inside <appUpdatesLink> and <adminLink> tags are the visible link labels.',
  },
});

const calloutStyles = xcss({
  backgroundColor: 'color.background.neutral',
  borderRadius: 'radius.small',
  paddingBlock: 'space.150',
  paddingInline: 'space.150',
});

export const RolloutScheduleCallout: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <Flex justifyContent="center" xcss={calloutStyles}>
      <Text size="small" color="color.text.subtle">
        {formatMessage(messages.adminCalloutText, {
          appUpdatesLink: (chunks: ReactNode) => (
            <Link
              href="https://support.atlassian.com/organization-administration/docs/view-all-changes-to-an-atlassian-app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {chunks}
            </Link>
          ),
          adminLink: (chunks: ReactNode) => (
            <Link
              href="https://admin.atlassian.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {chunks}
            </Link>
          ),
        })}
      </Text>
    </Flex>
  );
};
